import { LoaderIcon } from '@/components/ui/loader-icon.js';

export const LoadingPage = ({ message }: { message?: string }) => {
  return (
    <div
      className="h-full min-h-[100dvh] w-full grid place-content-center justify-items-center gap-3 p-4"
      {...(message ? { role: 'status', 'aria-live': 'polite' as const } : {})}
    >
      <span aria-hidden="true">
        <LoaderIcon />
      </span>
      {message ? <p>{message}</p> : null}
    </div>
  );
};
